import { post } from '../api.js';
import { currentParams } from '../router.js';
import { lucideIcons, esc } from '../app.js';

/**
 * Landing page reached by clicking the cancellation link in the
 * "your account is scheduled for deletion" email. Unauthenticated —
 * the token in the URL is the capability.
 */
export async function renderCancelCloseAccount(container) {
  const { params } = currentParams();
  const token = params.get('token');

  if (!token) {
    container.innerHTML = `
      <div class="login-card">
        <div class="msg msg-error">Missing cancellation token. Use the link from your email.</div>
      </div>`;
    lucideIcons();
    return;
  }

  container.innerHTML = `
    <div class="login-card">
      <div class="logo">
        <svg viewBox="0 0 32 32" width="48" height="48"><defs><linearGradient id="bk-cancel" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#3ecfb4"/><stop offset="100%" stop-color="#2a9d8f"/></linearGradient></defs><rect width="32" height="32" rx="7" fill="url(#bk-cancel)"/><rect x="10" y="14" width="12" height="10" rx="2" fill="#0c0e14"/><path d="M12.5 14V11a3.5 3.5 0 0 1 7 0v3" fill="none" stroke="#0c0e14" stroke-width="2.2" stroke-linecap="round"/><circle cx="16" cy="19" r="1.5" fill="url(#bk-cancel)"/><line x1="16" y1="20.5" x2="16" y2="22" stroke="url(#bk-cancel)" stroke-width="1.5" stroke-linecap="round"/></svg>
        <div class="brand">Blind<span>Keep</span></div>
      </div>
      <p class="loading" style="text-align:center">Cancelling scheduled deletion...</p>
    </div>`;
  lucideIcons();

  try {
    const result = await post('/auth/cancel-close-account', { token });
    const status = result.status === 'cancelled'
      ? 'Your scheduled account deletion has been cancelled.'
      : 'No pending deletion to cancel. Your account is safe.';
    container.innerHTML = `
      <div class="login-card">
        <div class="logo">
          <svg viewBox="0 0 32 32" width="48" height="48"><defs><linearGradient id="bk-cancel" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#3ecfb4"/><stop offset="100%" stop-color="#2a9d8f"/></linearGradient></defs><rect width="32" height="32" rx="7" fill="url(#bk-cancel)"/><rect x="10" y="14" width="12" height="10" rx="2" fill="#0c0e14"/><path d="M12.5 14V11a3.5 3.5 0 0 1 7 0v3" fill="none" stroke="#0c0e14" stroke-width="2.2" stroke-linecap="round"/><circle cx="16" cy="19" r="1.5" fill="url(#bk-cancel)"/><line x1="16" y1="20.5" x2="16" y2="22" stroke="url(#bk-cancel)" stroke-width="1.5" stroke-linecap="round"/></svg>
          <div class="brand">Blind<span>Keep</span></div>
        </div>
        <div class="msg msg-success">${esc(status)}</div>
        <p style="margin-top:1rem;text-align:center"><a href="#/login">Sign in</a></p>
      </div>`;
    lucideIcons();
  } catch (err) {
    container.innerHTML = `
      <div class="login-card">
        <div class="logo">
          <svg viewBox="0 0 32 32" width="48" height="48"><defs><linearGradient id="bk-cancel" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#3ecfb4"/><stop offset="100%" stop-color="#2a9d8f"/></linearGradient></defs><rect width="32" height="32" rx="7" fill="url(#bk-cancel)"/><rect x="10" y="14" width="12" height="10" rx="2" fill="#0c0e14"/><path d="M12.5 14V11a3.5 3.5 0 0 1 7 0v3" fill="none" stroke="#0c0e14" stroke-width="2.2" stroke-linecap="round"/><circle cx="16" cy="19" r="1.5" fill="url(#bk-cancel)"/><line x1="16" y1="20.5" x2="16" y2="22" stroke="url(#bk-cancel)" stroke-width="1.5" stroke-linecap="round"/></svg>
          <div class="brand">Blind<span>Keep</span></div>
        </div>
        <div class="msg msg-error">${esc(err.message || String(err))}</div>
        <p style="margin-top:1rem;text-align:center"><a href="#/login">Back to sign-in</a></p>
      </div>`;
    lucideIcons();
  }
}
